import 'ui/form-group/form-group';
import 'ui/password-input/password-input';

import { cadenzaSessionStorage } from 'cadenza/utils/storage/storage';

import '../css/login.css';

const loginStatus = new URLSearchParams(location.search).get('loginStatus');
if (loginStatus === 'loggedOut') {
  cadenzaSessionStorage.removeItem('savedPermalinkUrl');
} else {
  const loginForm = document.getElementById('loginForm');
  loginForm.onsubmit = function () {
    const savedPermalinkUrl = cadenzaSessionStorage.getItem('savedPermalinkUrl');
    document.getElementById('loginForm:savedPermalinkUrl').value = savedPermalinkUrl || '';
  };
}
